import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../context/ThemeContext';

const ScrollProgress = () => {
  const { themeColor } = useTheme();
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPosition = window.scrollY;
      const scrollProgress = (scrollPosition / totalHeight) * 100;
      setProgress(scrollProgress);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.div
      className="fixed top-0 left-0 right-0 h-1 z-[100]"
      style={{ backgroundColor: 'rgba(255,255,255,0.05)' }}
    >
      <motion.div
        className="h-full"
        style={{ 
          backgroundColor: themeColor.primary,
          width: `${progress}%`,
          boxShadow: `0 0 10px ${themeColor.primary}`
        }}
        transition={{ duration: 0.1 }}
      />
    </motion.div>
  );
};

export default ScrollProgress;
